var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUmbrella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 9.87156C21.1507 5.86639 18.5536 2.40867 14.8044 0.957181C11.0551 -0.494307 6.80676 0.313216 3.85156 3.03906C1.91774 4.81563 0.722995 7.25466 0.504688 9.87156C0.4687 10.2903 0.610048 10.705 0.894319 11.0145C1.17859 11.3241 1.5797 11.5002 2 11.5H10.25V16.75C10.25 18.4069 11.5931 19.75 13.25 19.75C14.9069 19.75 16.25 18.4069 16.25 16.75C16.25 16.3358 15.9142 16 15.5 16C15.0858 16 14.75 16.3358 14.75 16.75C14.75 17.5784 14.0784 18.25 13.25 18.25C12.4216 18.25 11.75 17.5784 11.75 16.75V11.5H20C20.4211 11.5015 20.8235 11.326 21.1088 11.0163C21.3941 10.7065 21.5361 10.2911 21.5 9.87156ZM2 10C2.34133 6.03268 5.24535 2.75937 9.14375 1.94781C8.045 3.4375 6.67344 6.07281 6.51594 10H2ZM8.01406 10C8.14438 7.11531 9.00125 5.04906 9.72969 3.79C10.0889 3.16455 10.5148 2.57988 11 2.04625C11.4843 2.57996 11.9093 3.16463 12.2675 3.79C13.5125 5.94063 13.9062 8.245 13.9831 10H8.01406ZM15.4813 10C15.3238 6.07281 13.9522 3.4375 12.8562 1.94313C16.7575 2.75294 19.663 6.02986 20 10H15.4813Z",
    fill: "#082C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella);
export default __webpack_public_path__ + "static/media/umbrella.00cc9c81471f5350c409e0c26859604e.svg";
export { ForwardRef as ReactComponent };